import { useCallback, useEffect } from 'react';

declare global {
	interface Window {
		fbq?: (...args: any[]) => void;
		_fbq?: any;
	}
}

type TrackEventPayload = Record<string, unknown>;

/**
 * Initializes Facebook Pixel (when id present) and exposes a safe event tracker.
 */
const useFacebookPixel = (pixelId?: string) => {
	useEffect(() => {
		if (!pixelId) return;

		if (!window.fbq) {
			(function (f: any, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
				if (f.fbq) return;
				n = f.fbq = function (...args: any[]) {
					n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
				};
				if (!f._fbq) f._fbq = n;
				n.push = n;
				n.loaded = true;
				n.version = '2.0';
				n.queue = [];
				t = b.createElement(e);
				t.async = true;
				t.src = v;
				s = b.getElementsByTagName(e)[0];
				s.parentNode!.insertBefore(t, s);
			})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

			(window as any).fbq('init', pixelId);
		}
	}, [pixelId]);

	const trackEvent = useCallback(
		(eventName: string, payload?: TrackEventPayload) => {
			if (!pixelId) return;
			const fbq = (window as any)?.fbq;
			if (typeof fbq !== 'function') return;

			if (payload) {
				fbq('track', eventName, payload);
			} else {
				fbq('track', eventName);
			}
		},
		[pixelId],
	);

	return { trackEvent };
};

export default useFacebookPixel;
